<template>
  <div
    class="w-full h-full flex flex-col items-center justify-center gap-6 p-4"
  >
    <div class="flex flex-col items-center gap-2 text-center max-w-lg">
      <BaseText
        type="heading"
        size="lg"
        class="text-text-loud"
      >
        Spendback Setup Complete
      </BaseText>
      <BaseText
        type="body"
        size="md"
        class="text-text-normal"
      >
        You are all setup to start recovering ad spend through Foreplay Lens & Spendback!
      </BaseText>
    </div>
    <button
      class="black-btn-primary flex items-center gap-1 pl-2.5 pr-1.5 py-1.5 rounded-md"
      @click="$emit('open-dashboard')"
    >
      <BaseText
        type="label"
        size="sm"
        class="text-white whitespace-nowrap"
      >
        Open Dashboard
      </BaseText>
    </button>
  </div>
</template>

<script>

export default {
  name: 'LensSpendBackComplete'
}
</script>
